export const TRIGGER_MIN_HEIGHT = {
  "0": "5",
  "1": "6",
  "2": "8",
  "3": "10",
};
